(function(){
  var AL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var AR='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
  function init(root){
    if(!root||root.getAttribute('data-ready'))return;
    root.setAttribute('data-ready','1');
    var track=root.querySelector('.zvc__track');
    if(!track)return;
    var slides=[].slice.call(root.querySelectorAll('.zvc__slide'));
    var n=slides.length,cur=0,timer=null;
    var delay=parseInt(root.getAttribute('data-delay'),10)||5000;
    var auto=root.getAttribute('data-autoplay')==='true';
    var design=!!(window.Shopify&&window.Shopify.designMode);
    var run=auto&&n>1&&!design;
    if(!run)root.classList.add('zvc--noauto');
    root.style.setProperty('--zvc-delay',(delay/1000)+'s');
    var prev=null,next=null,dots=[];
    function mk(cls,html,label){var b=document.createElement('button');b.type='button';b.className=cls;b.setAttribute('aria-label',label);if(html)b.innerHTML=html;return b;}
    function own(i){return parseFloat(getComputedStyle(slides[i]).getPropertyValue('--zvc-dur'))||0;}
    function dur(i){
      var c=own(i);
      if(c>0)return c*1000;
      var v=slides[i].querySelector('video');
      if(v&&isFinite(v.duration)&&v.duration>0)return Math.round(v.duration*1000);
      return delay;
    }
    function fill(k){
      var d=dots[k];if(!d||!d.firstChild)return;
      d.firstChild.style.animationDuration=(dur(k)/1000)+'s';
    }
    /* animated image (GIF/WebP): restart from frame 0 every time its slide appears */
    function anim(i){
      var im=slides[i].querySelector('img');if(!im||!im.parentNode)return;
      var s=im.currentSrc||im.src||'';
      if(!/\.(webp|gif|apng)(\?|$)/i.test(s))return;
      var c=im.cloneNode(true);im.parentNode.replaceChild(c,im);
    }
    if(n>1){
      if(root.getAttribute('data-arrows')==='true'){
        prev=mk('zvc__arrow zvc__arrow--prev',AL,'Previous slide');next=mk('zvc__arrow zvc__arrow--next',AR,'Next slide');
        root.appendChild(prev);root.appendChild(next);
      }
      if(root.getAttribute('data-dots')==='true'){
        var w=document.createElement('div');w.className='zvc__dots';
        slides.forEach(function(s,k){var d=mk('zvc__dot','<i></i>','Go to slide '+(k+1));if(k===0)d.setAttribute('aria-current','true');w.appendChild(d);dots.push(d);d.addEventListener('click',function(){go(k);start();});});
        root.appendChild(w);
      }
    }
    function vids(restart){
      slides.forEach(function(s,i){
        var v=s.querySelector('video');if(!v)return;
        if(i===cur){if(restart){try{v.currentTime=0;}catch(e){}}var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}
      });
    }
    function go(i){
      if(n<2)return;
      cur=(i+n)%n;
      track.style.transform='translateX(-'+(cur*100)+'%)';
      slides.forEach(function(s,k){s.setAttribute('aria-hidden',k===cur?'false':'true');});
      dots.forEach(function(d,k){
        if(k===cur){d.setAttribute('aria-current','true');var f=d.firstChild;if(f){f.style.animation='none';void f.offsetWidth;f.style.animation='';fill(k);}}
        else d.removeAttribute('aria-current');
      });
      vids(true);anim(cur);
    }
    function stop(){if(timer){clearTimeout(timer);timer=null;}root.classList.add('zvc--paused');}
    function tick(){go(cur+1);timer=setTimeout(tick,dur(cur));}
    function start(){stop();if(run){fill(cur);timer=setTimeout(tick,dur(cur));root.classList.remove('zvc--paused');}}
    slides.forEach(function(s,i){
      var v=s.querySelector('video');
      if(v)v.addEventListener('loadedmetadata',function(){if(i===cur&&run&&!root.matches(':hover'))start();});
    });
    if(prev)prev.addEventListener('click',function(){go(cur-1);start();});
    if(next)next.addEventListener('click',function(){go(cur+1);start();});
    var x0=null,y0=null;
    root.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});
    root.addEventListener('touchend',function(e){
      if(x0===null)return;
      var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){go(dx<0?cur+1:cur-1);start();}
      x0=null;
    },{passive:true});
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
    root.addEventListener('shopify:block:select',function(e){var i=slides.indexOf(e.target);if(i>-1){stop();go(i);}});
    vids(false);start();
    /* once the page has fully loaded, re-sync slide 1: restart its animation and the timer together */
    function aligned(){if(cur===0&&run){anim(0);start();}}
    if(document.readyState==='complete')aligned();else window.addEventListener('load',aligned);
  }
  function all(){[].forEach.call(document.querySelectorAll('.zvc'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();